import EmployeeSidebar from "../sidebar/userSidebar/EmployeeSidebar";
import { useEffect, useMemo, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { getSessionItem } from "../../utils/helper/session";
import ManagerDashComplianceTable from "../../components/managerDashComplianceTable/ManagerDashComplianceTable";
import ManagerDashUserStatusTable from "../../components/managerDashUserStatusTable/ManagerDashUserStatusTable";
import ManagerDashRequestsTable from "../../components/managerDashRequestsTable/ManagerDashRequestsTable";
import ManagerDashChart from "../../components/managerDashChart/ManagerDashChart";
import "primeicons/primeicons.css";
import "./DashboardMain.css";

function DashboardMain() {
  const user = getSessionItem("User");

  const [projects, setProjects] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [visibleSidebar, setVisibleSidebar] = useState(false);

  const storedProjects = JSON.parse(sessionStorage.getItem("projects") || "[]");

  const selectedProjectId = useMemo(() => {
    if (!selectedProject) return 0;
    return selectedProject.Id || selectedProject.id || 0;
  }, [selectedProject]);

  const listProjects = () => {
    setProjectsLoading(true);

    try {
      const storedProjects = sessionStorage.getItem("projects");
      setProjects(storedProjects ? JSON.parse(storedProjects) : []);
    } catch (error) {
      console.error(error);
      setProjects([]);
    } finally {
      setProjectsLoading(false);
    }
  };

  useEffect(() => {
    listProjects();
  }, []);

  const projectValueTemplate = (option, props) => {
    if (projectsLoading) {
      return (
        <span className="dd-placeholder-loading">
          <i className="pi pi-spinner dd-spin" />
        </span>
      );
    }

    if (!option) {
      return <span className="p-placeholder">{props.placeholder}</span>;
    }

    const label = option?.Name || option?.name || option?.label || String(option);
    return <span>{label}</span>;
  };

  if (!storedProjects || storedProjects.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#999", fontWeight: 400 }}>
          You don’t have any assigned projects yet to access{" "}
          <strong>Manager Dashboard</strong> page.
        </h1>
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ padding: "1rem 1rem 0" }}>Manager Dashboard</h1>

      <div className="manager-dash-box">
        <div className="manager-dash-project-dropdown">
          <div className="project-dropdown-with-spinner">
            <Dropdown
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.value)}
              optionLabel="name"
              options={projects}
              placeholder="Select a Project"
              valueTemplate={projectValueTemplate}
              disabled={projectsLoading || !projects?.length}
              aria-busy={projectsLoading}
              showClear
            />
          </div>

          <div>
            <Button
              label="Search User"
              icon="pi pi-search"
              severity="info"
              onClick={() => setVisibleSidebar(true)}
            />
          </div>
        </div>

        <div className="manager-dash-requests-box">
          <ManagerDashRequestsTable 
            selectedProjectId={selectedProjectId} 
          />
        </div>

        <div className="manager-dash-usersStatus-box">
          <ManagerDashUserStatusTable
            user={user}
            managerId={user.id}
            selectedProjectId={selectedProjectId}
            />
        </div>

        <div className="manager-dash-compliance-box">
          <ManagerDashComplianceTable
            user={user}
            selectedProjectId={selectedProjectId}
            />
        </div>

        <div className="manager-dash-chart-box">
          <ManagerDashChart
            user={user}
            managerId={user.id}
            selectedProjectId={selectedProjectId}
          />
        </div>
      </div>

      {visibleSidebar && (
        <EmployeeSidebar
          visible={visibleSidebar}
          onHide={() => setVisibleSidebar(false)}
        />
      )}
    </div>
  );
}

export default DashboardMain;